module.exports = __webpack_public_path__ + "static/media/family_office-bg.a880acaf.jpg";